module.exports = __webpack_public_path__ + "img/file-type-image.b3f3b1c3.png";